// Bootstrap: TanStack Query + TanStack Router + AuthGate + Toaster.
//
// Order matters: AuthGate must be ABOVE RouterProvider so __root.tsx can
// read useAuth() during render; ToastProvider must be ABOVE the
// RouterProvider so pages can call useToast(); QueryClientProvider
// wraps everything because both AuthGate and pages depend on it.

import './styles/globals.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';

import { AuthGate } from '@/components/layout/auth-gate';
import { ErrorBoundary } from '@/components/ui/error-boundary';
import { ToastProvider, Toaster } from '@/components/ui/toast';
import { queryClient } from '@/lib/query';
import { makeRouter } from '@/router';

const router = makeRouter(queryClient);

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Missing #root element in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <AuthGate>
            <RouterProvider router={router} />
          </AuthGate>
          <Toaster />
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
